import { AbstractPlayer } from './abstract-player'

/**
 * DistroScale video player.
 * Just for assigning element to the Store
 */
export class DistroScale extends AbstractPlayer {
    public constructor(protected element: HTMLElement) {
        super(element)
        this.iframeData = JSON.parse(this.element.dataset.evtVal || '{}')
    }

    /* eslint-disable @typescript-eslint/no-unused-vars */
    setMute(_: boolean) {
        return
    }
    setControls(_: boolean) {
        return
    }
    setLoop(_: boolean) {
        return
    }
    setAutoplay(_: boolean) {
        return
    }
    async init() {
        return
    }
    get title() {
        return ''
    }
    get index() {
        return 0
    }
    pause() {
        return
    }
    play() {
        return
    }
    playVideoAt(_: number) {
        return
    }
    destroy() {
        return
    }
    cuePlaylist(_: YT.IPlaylistSettings) {
        return
    }
    getState() {
        return ''
    }
    isPausable() {
        return true
    }
    onError(_: YT.OnErrorEvent | jwplayer.ErrorParam) {
        return
    }
    render() {
        return
    }
}
